import {
  Box,
  HStack,
  IconButton,
  Stack,
  Text,
  useClipboard,
  useToast,
} from "@chakra-ui/react";
import { MaterialIcon } from "../../../components/shared/MaterialIcon";

const SupportSettings = () => {
  const toast = useToast();

  const { onCopy, value } = useClipboard("support@geneial.com");

  const handleOnCopyEmail = () => {
    onCopy();

    toast({
      title: "Copied",
      description: value,
      status: "success",
      duration: 2000,
      isClosable: true,
    });
  };

  return (
    <Box w="full" h="full">
      <Stack
        spacing={8}
        maxW={"xl"}
        borderWidth="1px"
        mx="auto"
        py={8}
        px={8}
        rounded="md"
      >
        <Stack spacing={1}>
          <Text textStyle={"label"}>Support Email</Text>
          <HStack spacing={4} justify="space-between">
            <Text>{value}</Text>
            <IconButton
              size="sm"
              onClick={handleOnCopyEmail}
              icon={
                <MaterialIcon
                  fontSize="sm"
                  name="content_copy"
                  variant="outline"
                />
              }
              aria-label="close menu"
            ></IconButton>
          </HStack>
        </Stack>
        <Stack spacing={1}>
          <Text textStyle={"label"}>Version</Text>
          <HStack spacing={4} justify="space-between">
            <Text>1.3.0</Text>
          </HStack>
        </Stack>
      </Stack>
    </Box>
  );
};

export default SupportSettings;
